import { getUserCarDetailApi } from '~/server'

export function useAuto() {
  const publishStore = usePublishStore()
  const { formData } = storeToRefs(publishStore)
  const drivingLicenseFrontImg = ref('')

  async function getDefaultDriving() {
    try {
      const { data } = await getUserCarDetailApi()
      if (!data)
        return
      drivingLicenseFrontImg.value = data.drivingLicenseFrontImg ?? ''
      formData.value.isGetDefaultDriving = true

      formData.value.userName = data.carUserName ?? ''
      formData.value.sex = data.carUserSex ?? 0
      formData.value.phone = data.carUserPhone ?? ''
      formData.value.email = data.carUserEmail ?? ''

      formData.value.carBrandId = data.carBrandId
      formData.value.carSeriesId = data.carSeriesId
      formData.value.carModelId = data.carModelId ?? undefined
      formData.value.carVin = data.carVin ?? ''
      formData.value.carEngineNumber = data.carEngineNumber ?? undefined
      formData.value.carRegionPlate = data.carRegionPlate ?? undefined
      formData.value.carNumberPlate = data.carNumberPlate ?? undefined
      formData.value.carShoppingTime = data.carShoppingTime
      formData.value.firstFaultTime = data.firstFaultTime
      formData.value.carInsuranceCode = data.carInsuranceCode ?? undefined
      formData.value.carTravelKm = data.carTravelKm ?? undefined
      formData.value.carDealerId = data.carDealerId
      formData.value.carDealerLinkman = data.carDealerLinkman ?? undefined
      formData.value.carDealerPhone = data.carDealerPhone ?? undefined
      formData.value.carDealerName = data.carDealerName ?? undefined
      formData.value.carDealerAreaIds = [
        data.carDealerProvinceId ? String(data.carDealerProvinceId) : undefined,
        data.carDealerCityId ? String(data.carDealerCityId) : undefined,
      ]
    }
    catch (err) {
      recordError(err)
    }
  }

  return {
    drivingLicenseFrontImg,
    getDefaultDriving,
  }
}
